import http from '../../lib/http'
import { notify } from '../../lib/Notification/actions.js'

export const COMPARTMENT_RECEIVE = 'compartment/RECEIVE'
export const COMPARTMENT_RECEIVE_SUCCESS = 'compartment/RECEIVE_SUCCESS'
export const COMPARTMENT_RECEIVE_FAIL = 'compartment/RECEIVE_FAIL'

export const SPEC_DATA = 'spec_data/RECEIVE'
export const SPEC_DATA_SUCCESS = 'spec_data/RECEIVE_SUCCESS'
export const SPEC_DATA_FAIL = 'spec_data/RECEIVE_FAIL'

export const compartmentReceived = (clientName, patientId, compartment) => ({
  type: COMPARTMENT_RECEIVE_SUCCESS,
  compartment,
  patientId,
  clientName
})

export const compartmentReceive = (patientId, clientName) => (dispatch, getState) => {
  let state = getState()
  clientName = clientName ?? state.globalVars?.params?.clientName

  if (state.patient.loading) {
    return null
  }

  if (!patientId || !clientName) {
    return null
  }

  dispatch({ type: COMPARTMENT_RECEIVE })
  return http
    .getRequest(`/patients/${patientId}/compartment`, {}, { clientName })
    .then(data => dispatch(compartmentReceived(clientName, patientId, data)))
    .catch(err => {
      dispatch({
        type: COMPARTMENT_RECEIVE_FAIL,
        error: err
      })
      dispatch(notify('Patient compartment receive failure', true))
    })
}

export const gotSpecData = (clientName, patientId, specPercentage) => ({
  type: SPEC_DATA_SUCCESS,
  specPercentage,
  patientId,
  clientName
})

export const getSpecData = (patientId, clientName) => (dispatch, getState) => {
  let state = getState()
  clientName = clientName ?? state.globalVars?.params?.clientName

  if (state.patient.loadingSpec) {
    return null
  }

  if (!patientId || !clientName) {
    return null
  }
  dispatch({ type: SPEC_DATA })
  return http
    .getRequest(`/patients/${patientId}/specdata`, {}, { clientName })
    .then(function handleData (data) {
      dispatch(gotSpecData(clientName, patientId, data))
    })
    .catch(err => {
      dispatch({
        type: SPEC_DATA_FAIL,
        error: err
      })
      dispatch(notify('Patient spec data receive failure', true))
    })
}
